module.exports = __webpack_public_path__ + "static/person5-7af0077ca03e76794fddfa6ec77044bd.png";